export async function getAddress(coordinate) {
  const wrapLongitude = (lng) => {
    return ((((lng + 180) % 360) + 360) % 360) - 180; // Wraps longitude to [-180, 180]
  };

  const wrapLatitude = (lat) => {
    return Math.max(-90, Math.min(90, lat)); // Clamps latitude to [-90, 90]
  };

  return new Promise(function (resolve, reject) {
    let objAddress = {
      fullAddress: "",
      address: "",
      city: "",
      province: "",
      postalCode: "",
      country: "",
      lat: 0,
      lng: 0
    };
    let objRet = {
      objAddress: objAddress,
      message: ""
    };

    // Use the wrapping functions for latitude and longitude
    const fixedLatitude = wrapLatitude(coordinate?.lat);
    const fixedLongitude = wrapLongitude(coordinate?.lng);

    if (coordinate === null || fixedLatitude === null || fixedLongitude === null) {
      objRet.message = "Something wrong with GPS coordinates!";
      resolve(objRet);
    }

    fetch(
      `https://maps.google.com/maps/api/geocode/json?latlng=${fixedLatitude},${fixedLongitude}&sensor=true&key=${import.meta.env.REACT_APP_GOOGLE_MAP_KEY}`,
      {
        method: "GET",
        compress: true,
        headers: {
          Accept: "application/json"
        }
      }
    )
      .then((response) => response.json())
      .then((json) => {
        if (json.status !== "OK" && json.status !== "ZERO_RESULTS") {
          objRet.message = JSON.stringify(json.status);
          resolve(objRet);
        }

        let addressString = "",
          address = "",
          city = "",
          province = "",
          country = "",
          postalcode = "";
        objAddress.lat = fixedLatitude;
        objAddress.lng = fixedLongitude;

        if (json.results.length > 0) {
          if (json.results[0].address_components.length > 0) {
            for (let i = 0; i < json.results[0].address_components.length; i++) {
              let x = json.results[0].address_components[i];
              if (x.types[0] === "street_number") address += x.long_name + " ";
              if (x.types[0] === "route") address += x.long_name + " ";
              if (x.types[0] === "locality" || x.types[0] === "postal_town") city = x.long_name;
              if (x.types[0] === "administrative_area_level_1") province = x.short_name;
              if (x.types[0] === "country") country = x.long_name;
              if (x.types[0] === "postal_code" || x.types[1] === "postal_code")
                postalcode = x.long_name;
            }
            addressString = json.results[0].formatted_address;
            objAddress = {
              address: address,
              city: city,
              province: province,
              country: country,
              postalCode: postalcode,
              lat: fixedLatitude,
              lng: fixedLongitude,
              fullAddress: addressString
            };
            objRet.objAddress = objAddress;
          }
        }
        resolve(objRet);
      })
      .catch((error) => {
        console.log("FetchCurrentAddress -> Error when Fetching Current Address: ", error);
        reject({
          statusCode: 403,
          message: "Server not responding! " + error.message
        });
      });
  });
}
